"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.LargeWarningStatusIcon = function () { return (react_1.default.createElement("svg", { viewBox: "0 0 32 32" },
    react_1.default.createElement("path", { fill: "#f2c973", d: "M32 32H0L16 0z" }),
    react_1.default.createElement("path", { fill: "#444444", d: "M14 12h4v10h-4zm0 12h4v4h-4z" }))); };
//# sourceMappingURL=LargeWarningStatusIcon.js.map